import { DRAFT_SCHEMA_VERSION, DRAFT_MAX_AGE_MS } from './photorealisticConstants';

export function serializeDraftState(state) {
  return {
    schemaVersion: DRAFT_SCHEMA_VERSION,
    updatedAt: Date.now(),
    data: {
      polygons: state.polygons ?? null,
      detectedObjectsFromAPI: state.detectedObjectsFromAPI ?? [],
      pendingDetectedObjects: state.pendingDetectedObjects ?? null,
      objectChoiceStep: state.objectChoiceStep ?? 'initial',
      selectedPolygonIndex: state.selectedPolygonIndex ?? null,
      editingLayerIndex: state.editingLayerIndex ?? null,
      showPolygonsOverlay: Boolean(state.showPolygonsOverlay),
      showModelStudioPanel: Boolean(state.showModelStudioPanel),
      showHistoryPanel: Boolean(state.showHistoryPanel),
      showPromptPanel: Boolean(state.showPromptPanel),
      showRenderPanel: Boolean(state.showRenderPanel),
      showExportImagePanel: Boolean(state.showExportImagePanel ?? state.showRenderPanel),
      showFlythroughPanel: Boolean(state.showFlythroughPanel),
      exportImagePanelCollapsed: Boolean(state.exportImagePanelCollapsed),
      rightPanelCollapsed: Boolean(state.rightPanelCollapsed),
      userDefinedObjects: state.userDefinedObjects ?? [],
      selectedObjectIndices: Array.from(state.selectedObjectIndices ?? []),
      selectedUserDefinedIndices: Array.from(state.selectedUserDefinedIndices ?? []),
      reviewLowConfidenceEditIndex: state.reviewLowConfidenceEditIndex ?? null,
      reviewLowConfidenceSource: state.reviewLowConfidenceSource ?? null,
      ignoredLowConfidenceKeys: Array.from(state.ignoredLowConfidenceKeys ?? []),
      hideLowConfidenceBanner: Boolean(state.hideLowConfidenceBanner),
      interiorsFromExisting: Boolean(state.interiorsFromExisting),
      interiorsSavedOnce: Boolean(state.interiorsSavedOnce),
      swapped: Boolean(state.swapped),
      preview: state.preview ?? null,
      operationTypeForApply: state.operationTypeForApply ?? 'material_transfer',
      lastMaterialTransferResultKey: state.lastMaterialTransferResultKey ?? null,
      uploadModelMaskResults: Array.isArray(state.uploadModelMaskResults)
        ? state.uploadModelMaskResults
        : [],
      selectedUploadModelMaskRoomObjectId: state.selectedUploadModelMaskRoomObjectId ?? null,
      imageSelectionPanelCollapsed: Boolean(state.imageSelectionPanelCollapsed),
      studioCuratedLibraryItems: Array.isArray(state.studioCuratedLibraryItems)
        ? state.studioCuratedLibraryItems.map((item) => ({
            id: item?.id,
            name: item?.name ?? 'Model',
            category: item?.category ?? 'Other',
          }))
        : [],
      placedCuratedModels: Array.isArray(state.placedCuratedModels)
        ? state.placedCuratedModels.map((p) => ({
            placementId: p?.placementId,
            roomObjectId: p?.roomObjectId ?? p?.id,
            name: p?.name ?? 'Model',
            category: p?.category ?? 'Other',
            x: p?.x,
            y: p?.y,
            width: p?.width,
            aspectRatio: p?.aspectRatio,
          }))
        : [],
      pendingCuratedPlacement: state.pendingCuratedPlacement ?? null,
      selectedPlacedCuratedId: state.selectedPlacedCuratedId ?? null,
    },
  };
}

export function isDraftPayloadValid(payload) {
  if (!payload || payload.schemaVersion !== DRAFT_SCHEMA_VERSION) return false;
  if (!payload.data || typeof payload.data !== 'object') return false;
  if (typeof payload.updatedAt !== 'number') return false;
  if (Date.now() - payload.updatedAt > DRAFT_MAX_AGE_MS) return false;
  return true;
}
